import React, { useState, useEffect } from 'react';
import {
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody,
} from 'reactstrap';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import appState from '../../storages/mobx/appState';
import { English, Russian, Ukrainian } from '../../constant';
import chatStorage from './chatStorage';
import four from '../../../../../theme/theme/src/assets/images/user/4.jpg';
import { EricaHughes } from '../../../../../theme/theme/src/constant';
import usersStorage from '../Users/usersStorage';

function ChatActionsMenu({ t }) {
  const [dropdownOpen, setOpen] = useState(false);
  useEffect(() => {
    usersStorage.loadDataFromServer();
  }, [usersStorage.users.length]);
  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={() => setOpen(!dropdownOpen)} className="dropdown-container">
        <DropdownToggle className="language-indicator" outline color="transparent">
          <i className="fa fa-2x fa-ellipsis-v" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu" right>
          <DropdownItem
            onClick={() => chatStorage.toggleReassignDialog()}
            className="dropdown-item"
          >
            {t('chat.Reassign')}
          </DropdownItem>
          <DropdownItem divider />
        </DropdownMenu>
      </Dropdown>
      <Modal isOpen={chatStorage.showReassignDialog} toggle={chatStorage.toggleReassignDialog}>
        <ModalBody>
          <div className="people-list">
            <ul className="list digits custom-scrollbar">
              {usersStorage
                .users
                // .filter((user) => user.permissions.findIndex((item) => item == 'chat.reply') >= 0)
                .map((user) => (
                  <li key={user.id.toString()} className="clearfix flex" onClick={() => chatStorage.reassignDialog(user.id)}>
                    <img className="rounded-circle img-20 user-image" src={user.avatar || four} alt="" />
                    <div className="about flex flex-column flex-center-vertical">
                      <div className="name">
                        {user.name}
                        {' '}
                        {user.surname}
                      </div>
                      <div className="status" />
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

ChatActionsMenu.propTypes = {};

export default translate(observer(ChatActionsMenu));
